import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function DataAiPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'דאטה / AI – איך לבחור מסלול',
        metaTitle: 'קורס דאטה ואנליטיקס 2025 – Data Science, BI, Python | Kursi',
        slug: 'data-ai',
        metaDescription: 'קורסי דאטה ואנליטיקס 2025 – Data Science, BI, SQL, Python. מדריך לבחירת מסלול דאטה עם פרויקטים אמיתיים. קבלו 3 המלצות קורסים אישיות.',
        subtitle:
          'המפתח בתחום הזה: לבחור יעד (אנליסט/DS/ML) ולבנות פרויקטים אמיתיים. “AI” כסיסמה בלי פרקטיקה זה בזבוז זמן.',
        chips: ['SQL', 'Python', 'פרויקטים', 'תיק עבודות'],
        chatSeed: 'קורס דאטה AI',
        sections: [
          {
            id: 'tracks',
            title: 'איזה תפקיד אתה רוצה?',
            body:
              'אנליסט (BI) ≠ דאטה סיינס ≠ ML Engineer. קורס טוב אומר במפורש לאיזה יעד הוא מכוון.',
            bullets: ['BI/אנליסט: Dashboards + SQL', 'DS: מודלים + ניסויים', 'ML: פרודקשן + תשתיות'],
          },
          {
            id: 'skills',
            title: 'סטאק בסיסי שחייב להיות',
            body:
              'אם אין SQL ו-Python ברמה בסיסית — זה לא רציני. זה הבסיס לכל המסלולים.',
            bullets: ['SQL', 'Python + Pandas', 'הצגת תוצאות', 'פרויקט אחד אמיתי'],
          },
          {
            id: 'projects',
            title: 'פרויקטים שמעסיק מבין',
            body:
              'תיק עבודות צריך להיות ברור: בעיה → דאטה → ניתוח → תוצאה → החלטה.',
            bullets: ['Notebook/Repo מסודר', 'הסבר החלטות', 'מדדים ותוצאות', 'תוצר קריא'],
          },
        ],
        checklist: [
          'יש פרויקט עם דאטה אמיתי',
          'יש SQL + Python (לפחות בסיס)',
          'יש תיק עבודות ברור',
          'יש מסלול מוגדר (BI/DS/ML)',
          'יש משוב/בדיקה על תרגילים',
        ],
        redFlags: [
          '“AI” בלי פרויקטים',
          'אין SQL בכלל',
          'הכל תיאוריה בלי תוצר',
          'אין יעד ברור',
        ],
        faq: [
          { q: 'מה עדיף להתחיל: BI או DS?', a: 'לרוב BI/אנליסט הוא מסלול כניסה קל יותר. DS דורש יותר מתמטיקה וניסיון.' },
          { q: 'חייב מתמטיקה?', a: 'ל-ML/DS כן ברמה מסוימת. ל-BI פחות. קורס טוב יגיד את זה במפורש.' },
        ],
      }}
    />
  );
}
